<div>
  <div class="title-flex">
    <h3 class="title-with-icon">
      <svg-icon src="assets/images/icons/ip.svg" class="blue"></svg-icon>
      <span>{{ "ServiceElement.SURFinternetUplink" | translate }}</span>
    </h3>
  </div>
  <div class="card card--no-padding tabs">
    <div class="tabs__content">
      <div class="tabs__grid">
        <div class="tabs__grid-item">
          <service-summary
            [service]="subscription()"
            [vlanranges]="[]"
            [showTraffic]="false"
            [showTrafficButton]="true"
          ></service-summary>
        </div>
        <div class="tabs__grid-item">
          <div class="tabs__flex-center">
            <h3>{{ "ServiceElement.IPConfiguration" | translate }}</h3>
          </div>
          <div class="tabs__table">
            <div class="tabs__table-row">
              <div class="tabs__table-col">{{ "ServiceElement.DDoSFilter" | translate }}</div>
              <div class="tabs__table-col">{{ surfcertFilter() | enabled_or_value }}</div>
            </div>
            <div class="tabs__table-row">
              <div class="tabs__table-col">{{ "IP.IPv4MTU" | translate }}</div>
              <div class="tabs__table-col">{{ ipv4Mtu() }}</div>
            </div>
            <div class="tabs__table-row">
              <div class="tabs__table-col">{{ "IP.IPv6MTU" | translate }}</div>
              <div class="tabs__table-col">{{ ipv6Mtu() }}</div>
            </div>

            <div class="tabs__table-row">
              <div class="tabs__table-col">{{ "IP.IPPrefixes" | translate }}</div>
              <div class="tabs__table-col">
                <div class="tabs__overflow-box">
                  @for (prefix of ipPrefixes(); track prefix) {
                    <div class="tabs__overflow-box-item">{{ prefix }}</div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
